export default __webpack_public_path__ + "static/image3-d5794f37cca771982e305b2ba5332996.jpg";